export default __webpack_public_path__ + "img/7f4651c45806d56ed5f2a900b67b5475.svg";